import ActiveTabsTypes from './active-tab.types';

export const setActiveTab = (data) => ({
  type: ActiveTabsTypes.SET_ACTIVE_TAB,
  payload: data,
});

export const setShowModal = (data) => ({
  type: ActiveTabsTypes.SHOW_MODAL,
  payload: data,
});

export const setModalAction = (data) => ({
  type: ActiveTabsTypes.MODAL_ACTION,
  payload: data,
});

export const removeActiveTab = () => ({
  type: ActiveTabsTypes.REMOVE_ACTIVE_TAB,
});
